import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const AccordionHeader = ({ children, mods={}, mix={}, onClick, className: classNameTail }) => {
    const { className } = useMods(AccordionHeader, { mix, mods });

    return (
        <button
            type='button'
            className={ className + (classNameTail ? ' ' + classNameTail : '') }
            onClick={ onClick }
        >
            { children }
        </button>
    );
};

AccordionHeader.displayName = 'Accordion__Header';

AccordionHeader.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.object,
    mods: PropTypes.object,
    onClick: PropTypes.func
};

export default AccordionHeader;
